import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom-v5-compat";

import { Button, TitleBar, useSubmitButton } from "../../Atoms";
import { LogoImage } from "../../MainPage";
import { useVenue } from "../../VenueContext";
import { useNextCartMutation } from "../Cart/mutations";
import { useSession } from "../Session/SessionContext";
import { getTabTotal } from "../Session/sessionSelectors";

// This is no longer used, it was used in early debug versions of the clear cart flow
const ClearCart = () => {
  const { t } = useTranslation("onsite");

  const venue = useVenue();
  const session = useSession();

  const navigate = useNavigate();
  const outstandingBalance = getTabTotal(session.customerTab);
  const [submissionState, trackSubmit] = useSubmitButton();
  const nextCartMutation = useNextCartMutation();

  const closeCart = async () => {
    await nextCartMutation.mutateAsync();
    navigate("/");
  };
  return (
    <div className="space-y-24 pb-64 md:py-24">
      <div className="md:flex">
        <Link to="/" className="hidden flex-1 items-center space-x-16 md:flex">
          <div className="w-full max-w-[64px]">
            <LogoImage />
          </div>
          <div className="text-lg font-bold text-venue-primary">
            {venue.name}
          </div>
        </Link>
        <div className="md:flex-1">
          <TitleBar>
            <div className="md:text-4xl md:font-bold">
              {t("clearOrder.title")}
            </div>
          </TitleBar>
        </div>
        <div className="flex-1" />
      </div>

      <div className="mx-auto max-w-sm space-y-32 rounded-venue-brand border-[6px] border-venue-tertiary p-32">
        <div className="text-center font-bold">
          {}
          {outstandingBalance
            ? t("clearOrder.descriptionWithBalance")
            : t("clearOrder.description")}
        </div>
        <div>
          <Button
            submissionState={submissionState}
            submissionOptions={{ loadingMessage: t("clearOrder.clearing") }}
            alert
            onClick={trackSubmit(closeCart)}
          >
            {t("clearOrder.action")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ClearCart;
